import commonService from "../../common";

// book.price: null(バス無料チケット)の場合は空配列が返る
export const divisionArrange = (books) => {
  // booksからdivisionを取り出し、division_name, division_name_en, 各divisionの数量を配列に保持する
  var divisionList = [];
  var divisionNameList = [];
  var divisionNameEnList = [];
  var divisionCountList = [];
  // divisionの順番を揃えるため、idの降順に
  commonService.sort(books).forEach(function (book) {
    if (book.price) {
      if (!divisionList.includes(book.price.division)) {
        divisionList.push(book.price.division);
        divisionNameList.push(book.price.division_name);
        divisionNameEnList.push(book.price.division_name_en);
        divisionCountList.push(1);
      } else {
        var index = divisionList.indexOf(book.price.division);
        divisionCountList[index]++;
      }
    }
  });
  // ↑で作った配列から、divisionごとのObjectの配列を作る
  var returnDivisions = [];
  for (var i = 0; i < divisionList.length; i++) {
    returnDivisions.push({
      division: divisionList[i],
      label: divisionNameList[i],
      label_en: divisionNameEnList[i],
      count: divisionCountList[i],
    });
  }
  return returnDivisions;
};
